import React from 'react';
import { Button, Modal } from '@hydrodigital/design-system';

const DEFAULT_SUPPORT_EMAIL = 'support@hydrodigital.com';

interface ContactSupportModalProps {
	isOpen: boolean;
	onClose: () => void;
	userName: string;
	managerName: string;
	managerEmail: string;
}

const ContactSupportModal: React.FC<ContactSupportModalProps> = ({
	isOpen,
	onClose,
	userName,
	managerName,
	managerEmail,
}) => {
	const hasClientSuccessManager = managerName.length > 0 && managerEmail.length > 0;

	const supportMessage = hasClientSuccessManager ? (
		<>
			Hi {userName}, do you have a question? Our team is ready to help. Please contact your Client
			Success Manager, <strong>{managerName}</strong>, who can be reached at{' '}
			<strong>{managerEmail}</strong>. We will get back to you as soon as possible!
		</>
	) : (
		<>
			Hi {userName}, do you have a question? Our team is ready to help. Please contact us at{' '}
			<strong>{DEFAULT_SUPPORT_EMAIL}</strong>. We will get back to you as soon as possible!
		</>
	);

	return (
		<Modal isOpen={isOpen} onClose={onClose} draggable={false} size="lg">
			<Modal.Header>
				<Modal.Title text="Contact Support" />
			</Modal.Header>
			<Modal.Content>
				<div style={{ paddingTop: 8, color: '#434B56', fontSize: 14, lineHeight: '22px' }}>
					<p style={{ marginBottom: 16 }}>{supportMessage}</p>
				</div>
			</Modal.Content>
			<Modal.Footer>
				<div className="flex justify-end w-full">
					<Button
						label="OK"
						showIcon={false}
						onClick={onClose}
						className="w-32"
						variant="primary"
						size="small"
					/>
				</div>
			</Modal.Footer>
		</Modal>
	);
};

export default ContactSupportModal;
